import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { betslipStyle } from '@/features/betslip/betslip.style';

interface TextErrorProps {
	msg: string;
	msgResourceKey?: string;
}

export const TextError = ({ msg, msgResourceKey }: TextErrorProps) => {
	const t = useTranslations('General');

	return (
		<div className="ticket__row">
			<span className={clsx('text-error', betslipStyle.textError)}>{msgResourceKey ? t(msgResourceKey) : msg}</span>
		</div>
	);
}

export const TextErrorParlay = ({ msg }: TextErrorProps) => {
	return (
		<div className={clsx('bet-slip-parlay__payout text-error', betslipStyle.textError)}>{msg}</div>
	);
}